import BillingsOrderRailyTaxiRecalculateRequest, {
  BillingsOrderRailyTaxiRecalculateRequestBody,
} from "./billings-order-raily-taxi-recalculate.request";

const createBody = (
  request: BillingsOrderRailyTaxiRecalculateRequest,
): BillingsOrderRailyTaxiRecalculateRequestBody => {
  return {
    billingNodes: request.billingNodes,
    bonus: request.bonus,
    penalty: request.penalty,
    bonusType: request.bonusType,
    penaltyType: request.penaltyType,
  };
};

const billingsOrderRailyTaxiRecalculateRequestFactory = {
  createBody,
};

export default billingsOrderRailyTaxiRecalculateRequestFactory;
